import { createContext } from 'react';

export const TableFormContext = createContext<{ editInForm: boolean; viewInForm: boolean }>({
    editInForm: false,
    viewInForm: false,
});
